import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader, Input } from 'semantic-ui-react';
import {
  NmrHoursDurationDto,
  ChangeNmrHoursDurationDto,
  ChangeNmrHoursDurationStore
} from 'stores/configuration/events-n-requests/non-machine-related/nmr-hours-durations-store';
import { nameof } from 'utils/object';

interface ChangeNmrHoursDurationViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeNmrHoursDuration?: ChangeNmrHoursDurationStore;
  currentDto: NmrHoursDurationDto;
}

interface ChangeNmrHoursDurationViewState {
  userClickedSaved: boolean;
}

@connect(['changeNmrHoursDuration', ChangeNmrHoursDurationStore])
class ChangeNmrHoursDurationView extends React.Component<ChangeNmrHoursDurationViewProps, ChangeNmrHoursDurationViewState> {
  private get changeNmrHoursDurationStore() {
    return this.props.changeNmrHoursDuration;
  }

  constructor(props: ChangeNmrHoursDurationViewProps) {
    super(props);

    this.changeNmrHoursDurationStore.state.result = null;

    this.changeNmrHoursDurationStore.change({
      id: this.props.currentDto.id,
      hoursDuration: this.props.currentDto.hoursDuration
    });

    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeNmrHoursDurationViewProps) {
    if (this.changeNmrHoursDurationStore.state.result && this.changeNmrHoursDurationStore.state.result.isSuccess) {
      nextProps.onClose(true);
    } else {
      document.getElementById('hours-input').focus();
    }
  }

  @autobind
  private onChangeItem() {
    this.setState({ userClickedSaved: true });
    this.changeNmrHoursDurationStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeNmrHoursDurationStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    this.setState({ userClickedSaved: false });
    const change = {};
    change[property] = value;
    this.changeNmrHoursDurationStore.change({ ...this.changeNmrHoursDurationStore.state.item, ...change });
  }

  public render() {
    const { t, currentDto } = this.props;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeNmrHoursDurationStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit NMR Hours Duration')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeNmrHoursDurationStore.state.result && !this.changeNmrHoursDurationStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeNmrHoursDurationStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeNmrHoursDurationStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <div className={`field normal-looking-disabled-input`}>
                      <label>{t('Cluster')}</label>
                      <Input disabled value={currentDto.clusterName}></Input>
                    </div>
                  </Form.Field>

                  <Form.Field>
                    <div className={`field normal-looking-disabled-input`}>
                      <label>{t('Functional Area')}</label>
                      <Input disabled value={currentDto.functionalAreaName}></Input>
                    </div>
                  </Form.Field>
                  <Form.Field>
                    <div className={`field normal-looking-disabled-input`}>
                      <label>{t('Training Name')}</label>
                      <Input disabled value={currentDto.trainingNameName || '[ANY]'}></Input>
                    </div>
                  </Form.Field>

                  <Form.Input
                    required
                    focus={true}
                    id="hours-input"
                    type="number"
                    fluid
                    error={this.changeNmrHoursDurationStore.state.item.hoursDuration <= 0 && this.state.userClickedSaved}
                    label={t('Hours Duration')}
                    placeholder={t('Hours Duration')}
                    value={this.changeNmrHoursDurationStore.state.item.hoursDuration}
                    onChange={(e, { value }) =>
                      this.handleValue(nameof<ChangeNmrHoursDurationDto>('hoursDuration'), Math.abs(parseInt(value) || 0))
                    }
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeNmrHoursDurationView);
